import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { Element, scroller } from 'react-scroll';

import Checkbox from '../../components/Checkbox';
import BirthdateItem from '../../components/BirthdateItem';

import birthdates from '../../api/birthdates';
import useDiaryData from '../../hooks/useDiaryData';

const dateDisplayFormat = 'DD MMM YYYY';

const useStyles = makeStyles(theme => ({
	root: {
		maxWidth: 800,
		margin: 'auto',
		paddingBottom: 20,
		[theme.breakpoints.up('sm')]: {
			paddingLeft: 30,
			paddingRight: 30,
		}
	},
	date: {
		position: 'sticky',
		top: `calc(${theme.mixins.toolbar.minHeight}px + 58px)`,
		borderBottom: `1px solid #e0e0e0`,
		backgroundColor: 'white',
		fontSize: 18,
		fontWeight: 600,
		paddingTop: 10,
		paddingBottom: 5,
		//marginBottom: 5,
		zIndex: 1,
		paddingLeft: 10,
	},
	innerDate: {
		fontSize: 16,
		fontWeight: 300,
	},
	listWrapper: {
		backgroundColor: '#f9f9f9',
		//borderTop: `1px solid #e0e0e0`,
		[theme.breakpoints.up('sm')]: {
			borderLeft: `1px solid #e0e0e0`,
			borderRight: `1px solid #e0e0e0`,
		}
	},
	noFound: {
		color: '#9c9c9c',
		fontWeight: 300,
		fontSize: 13,
		padding: 10,
		borderBottom: `1px solid #e0e0e0`,
	},
	checkboxWrapper: {
		top: theme.mixins.toolbar.minHeight,
		position: 'sticky',
		zIndex: 2,
		backgroundColor: 'white',
		[theme.breakpoints.down('sm')]: {
			paddingLeft: 20,
		}
	}
}));

function Birthdates() {
	const theme = useTheme();
	const classes = useStyles();
	const [diary] = useDiaryData();
	const [data, setData] = useState([]);
	const [wholeYear, setWholeYear] = useState(false);

	const handleCheckboxChange = (event, value) => {
		setWholeYear(Boolean(value));
	};

	useEffect(() => {
		const getData = async () => {
			const { data, success } = await birthdates.getBirthdates();
			console.log(success, data);
			setData(data.birthdate);
		}

		getData();
	}, []);


	useEffect(() => {
		window.__scrollTo = (name, duration = 1500) => {
			scroller.scrollTo(name, {
				duration,
				delay: 100,
				offset: -1 * (theme.mixins.toolbar.minHeight + 58),
				smooth: 'easeOutQuart',
			});
		}
	}, [theme.mixins.toolbar.minHeight]);


	const selectedMonth = moment(diary.selectedDate).month();
	const formattedData = Boolean(wholeYear)
		? data
		: data.filter(e => moment(e.date).month() === selectedMonth);

	return (
		<div className={classes.root}>
			<div className={classes.checkboxWrapper}>
				<Checkbox
					label="Show Whole Year"
					value={wholeYear}
					onChange={handleCheckboxChange}
				/>
			</div>

			{!Boolean(formattedData.length) && (
				<Typography className={classes.noFound}>No birthdate found</Typography>
			)}

			{formattedData.map((e, i) => (
				<Element key={e.birthdateID} name={e.date}>
					<Typography className={classes.date}>
						{`${moment(e.date).format('ddd')} `}
						<span className={classes.innerDate}>
							{moment(e.date).format(dateDisplayFormat)}
						</span>
					</Typography>
					<div className={classes.listWrapper}>
						<BirthdateItem details={e} />
					</div>
				</Element>
			))}
		</div>
	);
}

export default Birthdates;
